module.exports = __webpack_public_path__ + "fonts/Formular-Bold.106d48c.woff2";